import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Prompt for an AI generated flow update
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGenerateFlow = packet => {
  return {
    type: 'REQUEST_GENERATE_FLOW',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGenerateFlowSuccess = data => ({
  type: 'RECEIVE_GENERATE_FLOW_SUCCESS',
  data
})

export const receiveGenerateFlowFail = data => ({
  type: 'RECEIVE_GENERATE_FLOW_FAIL',
  data
})

export const tryToGenerateFlow = packet => (dispatch, getState) => {

  dispatch(requestGenerateFlow(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  

  let fs = Cookies.get(process.env.REACT_APP_COOKIE_FEATURE_SWITCH)
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/generate-flow/' + packet.id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGenerateFlowSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGenerateFlowFail({errors:e, lastSubmit: packet}));
    })
}
